import React from "react";
import { useHistory } from "react-router-dom";
import { Button, makeStyles, Radio, RadioGroup, FormControlLabel, FormLabel, Grid, TextField, Typography } from "@material-ui/core";
import { Send } from "@material-ui/icons";
import axios from "axios";
import firebase from "../../firebase";
//import Background from "../../../contact.jpg";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));

export default function ContactForm() {
  const classes = useStyles();
  const history = useHistory();

  const [value, setValue] = React.useState('emailme');

  const initializeForm = () =>{
    document.getElementById("email").setAttribute("required", "");
    document.getElementById("number").removeAttribute("required");
  }

  window.onload = initializeForm; 

  const handleChange = (event) => {
    setValue(event.target.value);
    if (event.target.value === "emailme"){
      document.getElementById("email").setAttribute("required", "");
      document.getElementById("number").removeAttribute("required");
    }
    else {
      document.getElementById("email").removeAttribute("required");
      document.getElementById("number").setAttribute("required", "");
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    const firstName = document.getElementById("firstname").value;
    const lastName = document.getElementById("lastname").value;
    const email = document.getElementById("email").value;
    const number = document.getElementById("number").value;
    const subject = document.getElementById("subject").value;
    const message = document.getElementById("message").value;
    const method = document.querySelector('input[name="method"]:checked').value;

    axios({
      method: "POST",
      url: "https://formspree.io/xpzyvgnd",
      data: {
        firstName: firstName,
        lastName: lastName,
        number: number,
        email: email,
        subject: subject,
        message: message,
        method: method
      }
    });
    document.getElementById("contact-form").reset();
    const dbs = firebase.firestore();
    dbs.collection("emails").doc(email).set({
      firstName: firstName,
      lastName: lastName,
      number: number,
      email: email,
      subject: subject,
      message: message,
      method: method
    })
    // .then(function() {
    //   console.log("Document successfully written!");
    // })
    // .catch(function(error) {
    //     console.error("Error writing document: ", error);
    // });
    history.replace('/submit');
  };

  // const handleSubscribe = e => {
  //   e.preventDefault();
  //   const subscribe = document.getElementById("subscribe").value;
  //   const db = firebase.firestore();
  //   db.collection("subscribed").doc(subscribe).set({
  //     email: subscribe
  //   })
  //   // .then(function() {
  //   //   console.log("Document successfully written!");
  //   // })
  //   // .catch(function(error) {
  //   //     console.error("Error writing document: ", error);
  //   // });
  //   document.getElementById("subscribe-form").reset();
  //   history.replace('/subscribed');
  // };

  const sectionStyle = {
    background: "#ffffff",
    paddingTop: "80px",
    paddingBottom: "100px",
    position: "relative"
  };

  const headingStyle = {
    fontFamily: "'Century Gothic', -apple-system, sans-serif",
    fontSize: "clamp(2rem, 5vw, 2.75rem)",
    fontWeight: "700",
    background: "linear-gradient(135deg, #173962 0%, #1DAEE0 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    marginBottom: "48px",
    paddingTop: "0"
  };

  const formCardStyle = {
    backgroundColor: "#ffffff",
    padding: "48px",
    borderRadius: "24px",
    maxWidth: "700px",
    margin: "0 auto",
    boxShadow: "0 8px 40px rgba(23, 57, 98, 0.1)",
    border: "1px solid rgba(23, 57, 98, 0.05)"
  };

  const textFieldStyle = {
    width: "100%",
    marginBottom: "8px"
  };

  const radioSectionStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: "20px 0",
    background: "linear-gradient(135deg, #f8f9fa 0%, #e8f4f8 100%)",
    borderRadius: "16px",
    marginBottom: "24px"
  };

  const submitButtonStyle = {
    borderColor: "#173962",
    color: "#173962",
    borderRadius: "12px",
    padding: "14px 40px",
    fontWeight: "600",
    fontSize: "1rem",
    textTransform: "none",
    transition: "all 0.3s ease",
    marginTop: "16px"
  };

  return (
    <div
      id="contact"
      className="jumbotron jumbotron-fluid min-vh-100 m-0"
      data-spy="scroll"
      data-target="#mainNavbar"
      data-offset="0"
      style={sectionStyle}
    >
      <div className="container container-fluid text-center">
        <Typography
          variant="h2"
          display="block"
          align="center"
          id="contact-us"
          style={headingStyle}
        >
          Contact Us
        </Typography>

        <form
          autoCorrect="off"
          onSubmit={e => handleSubmit(e)}
          id="contact-form"
          style={formCardStyle}
        >
          <div className="form-row" style={{marginBottom: "16px"}}>
            <div className="col">
              <TextField
                required
                label="First Name"
                type="text"
                margin="normal"
                variant="outlined"
                id="firstname"
                placeholder="First Name"
                style={textFieldStyle}
              />
            </div>
            <div className="col">
              <TextField
                required
                label="Last Name"
                type="text"
                id="lastname"
                margin="normal"
                variant="outlined"
                placeholder="Last Name"
                style={textFieldStyle}
              />
            </div>
          </div>

          <div style={radioSectionStyle}>
            <FormLabel component="legend" style={{fontWeight: "600", color: "#173962", marginBottom: "12px"}}>
              How should we reach out?
            </FormLabel>
            <RadioGroup name="method" value={value}>
              <Grid container justifyContent="center" spacing={2}>
                <Grid item>
                  <FormControlLabel
                    value="emailme"
                    control={<Radio style={{color: "#173962"}} />}
                    label="Email Us!"
                    onClick={handleChange}
                  />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    value="callme"
                    control={<Radio style={{color: "#173962"}} />}
                    label="Call Us!"
                    onClick={handleChange}
                  />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    value="textme"
                    control={<Radio style={{color: "#173962"}} />}
                    label="Text Us!"
                    onClick={handleChange}
                  />
                </Grid>
              </Grid>
            </RadioGroup>
          </div>

          <div className="form-row" style={{marginBottom: "16px"}}>
            <div className="form-group col-md">
              <TextField
                label="Email Address"
                type="email"
                id="email"
                variant="outlined"
                placeholder="Email Address"
                style={textFieldStyle}
              />
            </div>
            <div className="form-group col-md">
              <TextField
                label="Phone Number"
                type="tel"
                id="number"
                variant="outlined"
                placeholder="Phone Number"
                style={textFieldStyle}
              />
            </div>
          </div>

          <div className="form-row" style={{marginBottom: "16px"}}>
            <div className="form-group col-md">
              <TextField
                label="Subject"
                type="text"
                id="subject"
                variant="outlined"
                placeholder="Subject"
                style={textFieldStyle}
              />
            </div>
          </div>

          <div className="form-group" style={{marginBottom: "24px"}}>
            <TextField
              required
              label="Message"
              type="text-area"
              id="message"
              multiline
              rows={5}
              variant="outlined"
              placeholder="Tell us about your project or question..."
              style={textFieldStyle}
            />
          </div>

          <div className="form-group">
            <Button
              style={submitButtonStyle}
              variant="outlined"
              size="large"
              type="submit"
              className={classes.button}
              endIcon={<Send />}
            >
              Send Message
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}